// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @formatter:off */
#cardIcon {
  cursor: pointer;
  margin-top: 46px;
}

select {
  cursor: pointer;
}

.subAccountCol, .depCol {
  width: 95%;
}

.wrapper {
  margin-top: 5px;
  padding: 0 40px 0 0;
}

.flat {
  margin: 0;
  padding: 0;
}

.filterFamily {
  margin-bottom: 5px;
}

div.filterFamily div:first-child {
  margin-bottom: 8px;
}

#columnsDisplay {
  width: 100%;
}

#columnsDisplay tr td:first-child,
#columnsDisplay tr td:nth-child(3) {
  width: 25px;
}

.filterFamily {
  display: flex;
  flex-direction: column;
  width: 360px;
}
.filterFamily .datepicker-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.filterFamily .datepicker-wrapper .datepicker-container {
  display: flex;
  flex-direction: column;
  width: 50%;
}
.filterFamily .datepicker-wrapper .datepicker-container:first-of-type {
  margin-right: 20px;
}
.filterFamily .datepicker-wrapper .datepicker-container .mat-mdc-form-field {
  display: flex !important;
}`, "",{"version":3,"sources":["webpack://./src/app/jobs/components/web/jobs-list-search-filters/jobs-list-search-filters.component.scss"],"names":[],"mappings":"AAAA,mBAAA;AACA;EACI,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,eAAA;EACA,mBAAA;AACJ;;AAEA;EACI,SAAA;EACA,UAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;;EAEI,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;AAER;AADQ;EACI,aAAA;EACA,sBAAA;EACA,UAAA;AAGZ;AAFY;EACI,kBAAA;AAIhB;AAFY;EACI,wBAAA;AAIhB","sourcesContent":["/* @formatter:off */\n#cardIcon {\n    cursor: pointer;\n    margin-top: 46px;\n}\n\nselect {\n    cursor: pointer;\n}\n\n.subAccountCol, .depCol {\n    width: 95%\n}\n\n.wrapper {\n    margin-top: 5px;\n    padding: 0 40px 0 0;\n}\n\n.flat {\n    margin: 0;\n    padding: 0;\n}\n\n.filterFamily {\n    margin-bottom: 5px\n}\n\ndiv.filterFamily div:first-child {\n    margin-bottom: 8px;\n}\n\n#columnsDisplay {\n    width: 100%;\n}\n\n#columnsDisplay tr td:first-child,\n#columnsDisplay tr td:nth-child(3) {\n    width: 25px;\n}\n\n.filterFamily {\n    display: flex;\n    flex-direction: column;\n    width: 360px;\n    .datepicker-wrapper {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-around;\n        .datepicker-container {\n            display: flex;\n            flex-direction: column;\n            width: 50%;\n            &:first-of-type {\n                margin-right: 20px;\n            }\n            .mat-mdc-form-field {\n                display: flex!important;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
